import { API_CALL } from '../../../../middleware/api';
import { actions as orgFilterActions } from '../../../../components/OrgSelect/orgFilterActions';

// Redux actions for the superuser "ACCESS obligations" tab.
//
// Endpoint convention: every action spells out the `portal/` prefix, exactly
// like the sibling ACCESS simulator tab does — the API middleware only prepends
// the environment base URL (constants.getBaseUrl()), not `/portal`.

const BASE = 'portal/dev/access-obligations';

export const LIST_ACCESS_OBLIGATIONS = 'LIST_ACCESS_OBLIGATIONS';
export const LIST_ACCESS_OBLIGATIONS_RESULT = `${LIST_ACCESS_OBLIGATIONS}/result`;

export const MOVE_ACCESS_OBLIGATION = 'MOVE_ACCESS_OBLIGATION';
export const MOVE_ACCESS_OBLIGATION_RESULT = `${MOVE_ACCESS_OBLIGATION}/result`;

export const RECHECK_ACCESS_OBLIGATION = 'RECHECK_ACCESS_OBLIGATION';
export const RECHECK_ACCESS_OBLIGATION_RESULT = `${RECHECK_ACCESS_OBLIGATION}/result`;

export const PREPARE_END_OF_PERIOD = 'PREPARE_END_OF_PERIOD';
export const PREPARE_END_OF_PERIOD_RESULT = `${PREPARE_END_OF_PERIOD}/result`;

export const TRIGGER_EARLY_SUCCESS = 'TRIGGER_EARLY_SUCCESS';
export const TRIGGER_EARLY_SUCCESS_RESULT = `${TRIGGER_EARLY_SUCCESS}/result`;

// A superuser usually has no organization of his own, so every call carries the
// org the tab is currently pointed at (`org_uuid`: a query parameter on GET, a
// body field on PUT). Left out when the caller has an org and the backend
// resolves it from the session.
const withOrg = (orgUUID, params) => (orgUUID ? { ...params, org_uuid: orgUUID } : params);

export const actions = {
  // Reused as-is: returns the orgs the superuser can act on, with `masked_id`
  // being the org UUID the endpoints expect.
  getMyOrgs: orgFilterActions.getMyOrgs,

  list: orgUUID => ({
    [API_CALL]: { method: 'GET', endpoint: `${BASE}/`, params: withOrg(orgUUID) },
    type: LIST_ACCESS_OBLIGATIONS,
  }),

  // move shifts one obligation: action is 'to_now' or 'past_deadline',
  // days_ago the offset the tester typed next to the button.
  move: (obligationID, action, daysAgo, orgUUID) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `${BASE}/${obligationID}/move`,
      data: { action, days_ago: daysAgo, ...withOrg(orgUUID) },
    },
    type: MOVE_ACCESS_OBLIGATION,
  }),

  // recheck stamps next_recheck_at = now without moving anything; it
  // deliberately takes no days_ago.
  recheck: (obligationID, orgUUID) => ({
    [API_CALL]: { method: 'PUT', endpoint: `${BASE}/${obligationID}/recheck`, data: withOrg(orgUUID) },
    type: RECHECK_ACCESS_OBLIGATION,
  }),

  prepareEndOfPeriod: (enrollmentUUID, daysAgo, orgUUID) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `${BASE}/prepare-end-of-period`,
      data: { enrollment_uuid: enrollmentUUID, days_ago: daysAgo, ...withOrg(orgUUID) },
    },
    type: PREPARE_END_OF_PERIOD,
  }),

  triggerEarlySuccess: (enrollmentUUID, daysAgo, orgUUID) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `${BASE}/trigger-early-success`,
      data: { enrollment_uuid: enrollmentUUID, days_ago: daysAgo, ...withOrg(orgUUID) },
    },
    type: TRIGGER_EARLY_SUCCESS,
  }),
};

export default actions;
